import './App.css';
import React, { useState, useRef, useMemo, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import HeaderMain from './component/HeaderMain';
import { Link, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import $ from "jquery";
import FortuneList from './routes/FortuneList';
import FortuneInfo from './routes/FortuneInfo';
import Constellation from './component/Constellation';
import Loading from './component/Loading';
import NotFound from './routes/NotFound';
import UnseResult from './routes/UnseResult';
import { UnseProvider } from './context/UnseContext';
import AgreePrivacy from './routes/AgreePrivacy';
import { Pagination } from 'swiper/modules';
import DaetongApp from './daetong/App';
import LightHouseApp from './lightHouse/App';

function App() {
  const [fortuneList, setFortuneList] = useState(false);
  const [agreePrivacyTab, setAgreePrivacyTab] = useState(false);
  const [data, setData] = useState(null);
  const [unseResult, setUnseResult] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const APIKEY = process.env.REACT_APP_UNSE_API_KEY;
  const memberId = localStorage.getItem("memberId");
  const siteCode = process.env.REACT_APP_SITE_CODE;
  // const isLogin = (memberId != 'null') || !memberId;

  useEffect(() => {
    $.ajax({
      url: `${API_BASE_URL}/getMain`,
      type: "POST",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify({ "member_id": memberId, "site_code": siteCode }),
      cache: false,
      headers: {
        APIKEY: APIKEY,
      },
      success: function (res) {
        if (res.code != "0") {
          alert(res.msg); return false;
        }
        // console.log("응답:", res);
        setData(res);
      },
      error: function (xhr, status, err) {
        console.error("에러:", err);
        // console.log("상태:", xhr.status, "응답:", xhr.responseText);
      },
    });

    localStorage.setItem("memberId", memberId);

  }, []);



  // function getUnseResult(unseId, memberId) {
  //   $.ajax({
  //     url: `${API_BASE_URL}/getUnse`, 
  //     type: "POST",
  //     contentType: "application/json",
  //     dataType: "json",
  //     data: JSON.stringify({"member_id":memberId, "unse_id":unseId}),
  //     cache: false,
  //     headers: {
  //       APIKEY: APIKEY,
  //     },
  //     success: function (res) {
  //       if(res.code != "0") {
  //         alert(res.msg); return false;
  //       }
  //       console.log("응답:", res);
  //       setUnseResult(res);
  //       // console.log(unseResult.unseResult);
  //     },
  //     error: function (xhr, status, err) {
  //       console.error("에러:", err);
  //       console.log("상태:", xhr.status, "응답:", xhr.responseText);
  //     },
  //   }); return;
  // }



  if (!data) {
    return;
    //  <Loading Constellation={Constellation} />;
  }

  const cards = data.unseList;
  const memberInfo = data.memberInfo;
  const menuList = data.menuList;

  return (
    <UnseProvider>
      <div className="App">
        <div className='inner'>
          <Routes>
            <Route path="/" element={
              <>
                <div className='mainContent'>
                  <div className='mainInner'>
                    <HeaderMain variant="mainHeader" menuList={menuList} />
                    <Constellation></Constellation>

                    <div className='meadBox'>
                      <div className='main_top_banner'>
                        <h4 className='bannerTitle'>
                          <img src={process.env.PUBLIC_URL + '/image/logo.png'} alt='별별운세' />
                        </h4>
                        <div className='userInfo'>
                          <div className='userInfo_text'>
                            <h5 className='userInfo_title'>{memberInfo.TITLE}</h5>
                            <div className='userInfo_sub'>
                              <FortuneResult memberInfo={memberInfo}></FortuneResult>
                            </div>
                          </div>
                          <Link to="/FortuneInfo" className='userScore'>
                            <img src={process.env.PUBLIC_URL + `/image/today_score${memberInfo.TODAY_SCORE}.png`} />
                          </Link>
                        </div>
                      </div>
                      <div className='main_card_list'>
                        <div className='main_card_inner'>
                          <FortuneCards cards={cards} memberId={memberId} />
                        </div>
                      </div>
                      <Link to="/FortuneList" className='listBtn'>
                        <img src={process.env.PUBLIC_URL + '/image/mainList_menu.png'} />
                      </Link>
                    </div>

                  </div>
                </div>
              </>
            } />
            <Route path="/FortuneInfo/:orderId" element={
              <div className='FortuneInfoPage'>
                <HeaderMain variant="backHeader" menuList={menuList} />
                <Constellation></Constellation>
                <FortuneInfo cards={cards} menuList={menuList} Loading={Loading} Constellation={Constellation} />
              </div>
            } />
            <Route path="/FortuneInfo" element={
              <div className='FortuneInfoPage'>
                <HeaderMain variant="backHeader" menuList={menuList} />
                <Constellation></Constellation>
                <FortuneInfo cards={cards} menuList={menuList} Loading={Loading} Constellation={Constellation} />
              </div>
            } />
            <Route path='/UnseResult' element={
              <div className='UnseResultPage'>
                <HeaderMain variant="backHeaderOnly" menuList={menuList} />
                <Constellation></Constellation>
                <UnseResult unseResult={unseResult} />
              </div>
            } />
            <Route path='/FortuneList' element={
              <div className="fortuneListPage">
                <HeaderMain variant="backHeader" menuList={menuList} />
                <FortuneList cards={cards} fortuneList={fortuneList} />
                <Constellation></Constellation>
              </div>
            } />
            <Route path='/AgreePrivacy' element={
              <div className="agreePrivacyPage">
                <HeaderMain variant="subHeader" setFortuneList={setFortuneList} menuList={menuList} />
                <AgreePrivacy></AgreePrivacy>
              </div>
            } />
            <Route path='/daetong/*' element={<DaetongApp/>} />
            <Route path='/lightHouse/*' element={<LightHouseApp/>} />
            <Route path='*' element={<NotFound />} />
          </Routes>

          {/* <div className={fortuneList ? 'fortuneListPage active' : 'fortuneListPage'}>
              <HeaderMain variant="subHeader" setFortuneList={setFortuneList} menuList={menuList} setAgreePrivacyTab={setAgreePrivacyTab}/>
              <FortuneList cards={cards} fortuneList={fortuneList} setFortuneList={setFortuneList}/>
              <Constellation></Constellation>
            </div> */}

        </div>
      </div>
    </UnseProvider>
  );
}

function FortuneCards({ cards }) {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);

  return (
    <Swiper
      modules={[Pagination]}
      pagination={{ dynamicBullets: true }}
      slidesPerView={"auto"}
      centeredSlides={true}
      // spaceBetween={20}
      className="fortune-swiper"
      onSwiper={(swiper) => {
        swiperRef.current = swiper;
        setActiveIndex(swiper.activeIndex);
      }}
      onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
    >
      {cards.map((card, index) => {
        const isActive = index === activeIndex;

        return (
          <SwiperSlide key={index}>
            <div
              className={
                "fortune-card" + (isActive ? " is-active" : " is-inactive")
              }
              onClick={() => {
                const swiper = swiperRef.current;
                if (isActive) {
                  navigate(`/FortuneInfo/${card.ORDER_ID}`);
                  return;
                }
                if (swiper) swiper.slideTo(index);
              }}
            >
              <div className="card_item">
                <div className="card-front">
                  <img src={process.env.PUBLIC_URL + `${card.FILE_PATH}`} />
                  <div className="cardTextBox">
                    <h4 className="fortuneTitle">{card.TITLE}</h4>
                    <p>{card.CONTENT}</p>
                  </div>
                  <div className="cardIllu">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        `/image/unsecard/unsecardIllu${card.ORDER_ID}.png`
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}

function FortuneResult({ memberInfo }) {
  return (
    <div dangerouslySetInnerHTML={{ __html: memberInfo.CONTENT }} />
  );
}


export default App;
